import { useMutation } from '@tanstack/react-query';

import axios from 'src/lib/axios';
import { MutationConfig } from 'src/lib/react-query';
import { GeneralSmartParkError } from 'src/registry/types/axios';
import { formatResourcePath } from 'src/utils/regex';

const RESOURCE = `sp-core/:parkingId/paystations/pay-station/:payStationId/create-api-key/`;

type MutationFnType = typeof mutationFn;

type PayStationApiKey = {
    api_key: string;
};

type DTO = {
    parkingId: string;
    payStationId: string;
};
const mutationFn = ({ payStationId, parkingId }: DTO): Promise<PayStationApiKey> => {
    return axios.post(formatResourcePath(RESOURCE, { payStationId, parkingId }));
};

const useMutationHook = (options: MutationConfig<MutationFnType, GeneralSmartParkError>) =>
    useMutation({
        mutationFn,
        ...options,
    });

export { useMutationHook as useCreatePayStationApiKey };
